import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import SurveyStatisticsManager from 'managers/statistics/survey';
import { IWCCStorageManager } from 'managers/iStorage';
import { SurveyManager } from 'managers/topic/survey';
import { EffectsContainer } from 'mixins/withEffects';
import SurveyStatisticsModel from './model';
import { SurveyStatisticsPageVMConfig } from './page';
import './survey.html';
import './survey.scss';

components
    .registerLocal('survey-statistics-page', () => require('./page'))
    .registerLocal('survey-statistics-question', () => require('./question'))
    .registerLocal('survey-statistics-question-section', () => require('./questionSection'))
    .registerLocal('survey-statistics-question-choice', () => require('./questionChoice'));

@injectable()
export default class SurveyStatisticsVM {
    static Model = SurveyStatisticsModel

    labels = labels;

    pagesConfigs: Subscribable<Array<SurveyStatisticsPageVMConfig>>

    ready: Subscribable<boolean>
    loading: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) model: SurveyStatisticsModel,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        const statManager = storage.get(SurveyStatisticsManager, { topicId: model.topicId });
        const stat = statManager.pluck(m => m.stat);
        const statPages = stat.pluck(m => m.pages, []);
        const statReady = stat.isNotNull();

        const surveyManager = storage.get(SurveyManager, { topicId: model.topicId });
        const survey = surveyManager.pluck(m => m.survey);
        const surveyPages = survey.pluck(s => s.pages);
        const surveyReady = survey.isNotNull();

        this.pagesConfigs = statPages.map(statPage => (<SurveyStatisticsPageVMConfig>{
            surveyPage: surveyPages.find(page => page.pageId() == statPage.pageId()),
            surveyStatPage: statPage
        }));

        this.ready = ko.pureComputed(() => statReady() && surveyReady());
        this.loading = this.ready.not();

        const theme = model.theme;

        effects.register([
            model.ready.attachTo(this.ready),

            () => () => model.reset()
        ]);

        effects.register((statManager, filterData) => {
            if (statManager != undefined)
                statManager.filterData(filterData);
        }, [statManager, model.filterData]);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'survey-statistics': true,
                'survey-statistics--classic': theme.is(function (theme) { return theme === 'classic' }),
                'survey-statistics--dark': theme.is(function (theme) { return theme === 'dark' }),
                'survey-statistics--light': theme.is(function (theme) { return theme === 'light' })
            }
        });
    }    
}